"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.SIDEBAR = exports.SIZE_WIDTH_MAP = exports.SIZE_HEIGHT_MAP = exports.SIZES = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const _ui_1 = require("@ui");
const ac_1 = require("@app/ac");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_modal_1 = require("@app/util/modal/use-modal");
const units_1 = require("@app/util/units");
require("./index.scss");
exports.SIZES = Object.freeze({
    XS: 'size-xs',
    S: 'size-s',
    M: 'size-m',
    L: 'size-l',
    XL: 'size-xl',
    FULLSCREEN: 'size-full',
});
exports.SIZE_HEIGHT_MAP = Object.freeze({
    [exports.SIZES.XS]: '12.375rem',
    [exports.SIZES.S]: '20.75rem',
    [exports.SIZES.M]: '41.6875rem',
    [exports.SIZES.L]: '41.6875rem',
    [exports.SIZES.XL]: '41.6875rem',
    [exports.SIZES.FULLSCREEN]: '100vh',
});
exports.SIZE_WIDTH_MAP = Object.freeze({
    [exports.SIZES.XS]: '17.375rem',
    [exports.SIZES.S]: '17.375rem',
    [exports.SIZES.M]: '17.375rem',
    [exports.SIZES.L]: '43.75rem', // 700 px
    [exports.SIZES.XL]: '61.3125rem',
    [exports.SIZES.FULLSCREEN]: '100vw',
});
exports.SIDEBAR = Object.freeze({ WIDTH: '10.5rem' });
const isRem = (v) => v.includes('rem');
const isVh = (v) => v.includes('vh');
const isVw = (v) => v.includes('vw');
const getRawValue = (val) => {
    const _parsedVal = /((?:\d|\.|,)+)\w+/g.exec(val)?.[1];
    return (0, util_1.isDefined)(_parsedVal) ? parseFloat(_parsedVal) : 0;
};
const remToPx = (rem) => {
    return (0, units_1.getRem)(rem);
};
const vhToPx = (vh) => {
    const VH_INDEX = window.innerHeight / 100;
    return vh * VH_INDEX;
};
const vwToPx = (vw) => {
    const VW_INDEX = window.innerWidth / 100;
    return vw * VW_INDEX;
};
const getModalDimensions = (size, hasSidebar) => {
    const heightString = exports.SIZE_HEIGHT_MAP[size];
    const widthString = exports.SIZE_WIDTH_MAP[size];
    const isHeightRem = isRem(heightString);
    const isHeightVh = isVh(heightString);
    const isWidthRem = isRem(widthString);
    const isWidthVw = isVw(widthString);
    const rawHeight = getRawValue(heightString);
    const rawWidth = getRawValue(widthString);
    const processedHeight = isHeightRem
        ? remToPx(rawHeight)
        : isHeightVh
            ? vhToPx(rawHeight)
            : rawHeight;
    const processedWidth = isWidthRem
        ? remToPx(rawWidth)
        : isWidthVw
            ? vwToPx(rawWidth)
            : rawWidth;
    const processedSidebarWidth = isRem(exports.SIDEBAR.WIDTH)
        ? remToPx(getRawValue(exports.SIDEBAR.WIDTH))
        : isVw(exports.SIDEBAR.WIDTH)
            ? vwToPx(getRawValue(exports.SIDEBAR.WIDTH))
            : getRawValue(exports.SIDEBAR.WIDTH);
    return {
        height: processedHeight,
        width: hasSidebar ? processedWidth + processedSidebarWidth : processedWidth,
    };
};
const getWindowDimensions = () => {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
};
// dragging functionality (separated as a component, so there aren't any problems with React Hooks when the whole modal is set to null)
const DraggableContent = ({ size, children, hasSidebar, dataTour }) => {
    const { width: modalWidth, height: modalHeight } = getModalDimensions(size, hasSidebar);
    const { height: windowHeight } = getWindowDimensions();
    const calculatedModalHeight = size !== exports.SIZES.FULLSCREEN
        ? modalHeight >= windowHeight
            ? windowHeight
            : modalHeight
        : modalHeight;
    const [dragStart, setDragStart] = react_1.default.useState({ x: 0, y: 0 });
    const [pos, setPos] = react_1.default.useState({
        x: '50%',
        y: size === exports.SIZES.FULLSCREEN
            ? '0'
            : modalHeight + 60 < windowHeight
                ? `${(windowHeight - modalHeight) / 2}px`
                : '0',
    });
    const isDraggableTarget = (e) => {
        return Boolean(size !== exports.SIZES.FULLSCREEN &&
            document
                .elementsFromPoint(e.pageX, e.pageY)
                .some((element) => element.classList.contains('ds-modal-header')));
    };
    const handleDragStart = (e) => {
        if (!isDraggableTarget(e) || size === exports.SIZES.FULLSCREEN) {
            e.preventDefault();
        }
        else {
            setDragStart({
                x: e.clientX - e.currentTarget.offsetLeft,
                y: e.clientY - e.currentTarget.offsetTop,
            });
        }
    };
    const handleDragEnd = (e) => {
        if (size !== exports.SIZES.FULLSCREEN) {
            setPos({ x: e.clientX - dragStart.x, y: e.clientY - dragStart.y });
            setDragStart({ x: 0, y: 0 });
        }
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('ds-modal-content'), "data-tour": dataTour, draggable: size !== exports.SIZES.FULLSCREEN, onDragStart: handleDragStart, onDragEnd: handleDragEnd, style: {
            top: pos.y,
            left: pos.x,
            transform: 'translateX(-50%)',
            width: modalWidth,
            height: calculatedModalHeight,
            margin: size === exports.SIZES.FULLSCREEN ? '0' : undefined,
        } }, children));
};
/**
 *
 * @see `modal-sidebar-button.tsx` Use ModalSidebarButton in Sidebar
 */
const Modal = ({ size, headerContent, sidebarContent, footerContent, footerWithoutPadding = false, sections, extraHeaderButtons, className, isLoading, children, noClose, afterClose, displayCloseButton, fullHeight = false, testid, overSidebar, dataTour, }) => {
    // Important first stuff
    const { closeModal } = (0, use_modal_1.useModal)();
    const dispatch = (0, store_1.useRootDispatch)();
    const close = react_1.default.useCallback(async () => {
        await dispatch((0, ac_1.setModal)(null));
        closeModal();
    }, [dispatch]);
    const modal = (0, store_1.useRootSelector)((state) => state.modal);
    (0, react_1.useEffect)(() => {
        const handleKeypress = async (evt) => {
            // Esc
            if (evt.code === 'Escape' && !noClose) {
                await close();
                afterClose?.();
            }
            // Enter
            if (evt.code === 'Enter') {
                const btns = document.querySelectorAll('.ds-modal-footer .ds-button.contained:not(.disabled)');
                if (btns.length)
                    btns[btns.length - 1].click();
            }
        };
        document.addEventListener('keydown', handleKeypress, false);
        return () => {
            document.removeEventListener('keydown', handleKeypress, false);
        };
    }, [afterClose, close, noClose]);
    // Breaks useModal functionality
    // if (!modal) {
    //   return (
    //     <div className='ds-modal-container'>
    //       <div className='ds-modal-underlay' />
    //     </div>
    //   )
    // }
    const closeIcon = noClose ? null : (react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.close1, size: _ui_1.Icon.SIZES.SMALL, color: _ui_1.Icon.COLORS.PRIMARY, onClick: async () => {
            await close();
            afterClose?.();
        } }));
    const hasHeaderContent = Boolean(headerContent || extraHeaderButtons?.length);
    const hasSidebarContent = (0, util_1.isDefined)(sidebarContent);
    return (react_1.default.createElement("div", { "data-testid": testid, className: (0, classnames_1.default)('ds-modal-container', className, {
            'is-open': true,
            'show-nav': true || modal?.data?.showNav,
            'over-sidebar': typeof overSidebar === 'undefined'
                ? true || modal?.data?.overSidebar
                : overSidebar,
        }) },
        react_1.default.createElement("div", { onClick: noClose
                ? undefined
                : async () => {
                    await close();
                    afterClose?.();
                }, className: 'ds-modal-underlay' }),
        react_1.default.createElement(DraggableContent, { size: size, hasSidebar: hasSidebarContent, dataTour: dataTour },
            react_1.default.createElement("div", { style: { height: '100%', width: '100%' } },
                hasHeaderContent && (react_1.default.createElement("div", { className: 'ds-modal-header' },
                    headerContent,
                    react_1.default.createElement("div", { className: 'ds-modal-header-buttons' },
                        extraHeaderButtons?.length
                            ? extraHeaderButtons.map((button, index) => (react_1.default.createElement(react_1.default.Fragment, { key: `ds-modal-header-button-${index}` }, button)))
                            : null,
                        displayCloseButton ? (react_1.default.createElement("div", { className: 'close-icon-container' }, closeIcon)) : null))),
                !hasHeaderContent && displayCloseButton && (react_1.default.createElement("div", { className: 'just-close' }, closeIcon)),
                react_1.default.createElement("div", { style: {
                        display: 'flex',
                        height: fullHeight ? '100%' : 'calc(100% - 3.125rem - 4.125rem)',
                    } },
                    (0, util_1.isDefined)(sidebarContent) && (0, util_1.isNotNull)(sidebarContent) && (react_1.default.createElement("div", { style: {
                            width: exports.SIDEBAR.WIDTH,
                            height: '100%',
                            borderRight: 'solid 1px #d9e3ff',
                        } }, sidebarContent)),
                    react_1.default.createElement("div", { style: {
                            width: getModalDimensions(size, false).width,
                            position: 'relative',
                        }, className: 'ds-modal-sections' }, isLoading ? (react_1.default.createElement(_ui_1.Loader, { size: _ui_1.Loader.SIZES.SMALL })) : sections?.length ? (sections.map((sec, idx) => {
                        return (react_1.default.createElement("div", { className: 'ds-modal-content-section', key: idx }, sec));
                    })) : (children))),
                !isLoading && footerContent ? (react_1.default.createElement("div", { className: (0, classnames_1.default)('ds-modal-footer', {
                        'no-padding': footerWithoutPadding,
                    }) }, footerContent)) : null))));
};
exports.Modal = Modal;
exports.Modal.defaultProps = {
    size: exports.SIZES.M,
    isLoading: false,
    noClose: false,
    style: undefined,
    className: undefined,
    extraHeaderButtons: [],
    children: null,
    afterClose: () => null,
    displayCloseButton: true,
    overSidebar: undefined,
    testid: undefined,
};
exports.Modal.SIZES = exports.SIZES;
